/**
 * proteinPositionFilter_UserSelections_Component.tsx
 *
 * Protein Position Filter User Selections
 *
 * Used in the 2 column format in Peptide, Single Protein, QC Filters and Options block
 *
 */

import React from 'react'

import {
    ProteinPositionFilter_UserInput__Component__UserSelectionData_Root,
    ProteinPositionFilter_UserInput__Component__UserSelectionData_SingleProtein,
    ProteinPositionFilter_UserInput__Component__UserSelectionData_SingleRange
} from "page_js/data_pages/common_components__react/protein_position_filter_component__not_single_protein/protein_position_filter__user_input_component/proteinPositionFilter_UserInput__Component__UserSelectionData";
import {
    ProteinPositionFilter_UserInput__Component__ProteinData_Root
} from "page_js/data_pages/common_components__react/protein_position_filter_component__not_single_protein/protein_position_filter__user_input_component/proteinPositionFilter_UserInput__Component__ProteinData";
import {
    ProteinPositionFilter_UserInput__Component,
    ProteinPositionFilter_UserInput__Component__Get_ProteinData_Root_UserSelectionData_Root_ReturnPromise_CallbackFunction,
    ProteinPositionFilter_UserInput__Component__Save_CallbackFunction,
    ProteinPositionFilter_UserInput__Component__Save_CallbackFunction_Params
} from "page_js/data_pages/common_components__react/protein_position_filter_component__not_single_protein/protein_position_filter__user_input_component/proteinPositionFilter_UserInput__Component";
import {
    ProteinPositionFilter_UserSelections_StateObject,
    ProteinPositionFilter_UserSelections_StateObject_Get_RangeEntries_For_ProteinSequenceVersionId,
    ProteinPositionFilter_UserSelections_StateObject_Get_RangeEntries_Root,
    ProteinPositionFilter_UserSelections_StateObject_Get_RangeEntries_SingleRange
} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__peptide_page__components/protein_position_filter_component/js/proteinPositionFilter_UserSelections_StateObject";
import { reportWebErrorToServer } from "page_js/common_all_pages/reportWebErrorToServer";
import {
    Tooltip__green_question_mark_in_circle__tooltip_on_hover__Component
} from "page_js/common_all_pages/tooltip__green_question_mark_in_circle__tooltip_on_hover__react_component/tooltip__green_question_mark_in_circle__tooltip_on_hover__react_component";
import {
    proteinPositionFilter_UserSelections_Build_ProteinNamesLengths_Data_ForComponent
} from "page_js/data_pages/common_filtering_code_filtering_components__except_mod_main_page/filter_on__components/filter_on__peptide_page__components/protein_position_filter_component/js/proteinPositionFilter_UserSelections_Build_ProteinNamesLengths_Data_ForComponent";
import {
    CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
} from "page_js/data_pages/common_data_loaded_from_server__per_search_plus_some_assoc_common_data__with_loading_code__except_mod_main_page/commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root";

export type ProteinPositionFilter_UserSelections_Component__UpdateMadeTo_proteinPositionFilter_UserSelections_StateObject = () => void;

/**
 *
 */
export interface ProteinPositionFilter_UserSelections_Props {

    proteinPositionFilter_UserSelections_Component_Force_ReRender_Object : object
    proteinPositionFilter_UserSelections_StateObject : ProteinPositionFilter_UserSelections_StateObject;

    projectSearchIds : Array<number>
    commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root: CommonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root

    updateMadeTo_proteinPositionFilter_UserSelections_StateObject_Callback : ProteinPositionFilter_UserSelections_Component__UpdateMadeTo_proteinPositionFilter_UserSelections_StateObject
}

interface ProteinPositionFilter_UserSelections_State {

    forceRerender_Object?: object
}

/**
 *
 */
export class ProteinPositionFilter_UserSelections extends React.Component< ProteinPositionFilter_UserSelections_Props, ProteinPositionFilter_UserSelections_State > {

    private _get_ProteinData_ReturnPromise_CallbackFunction_BindThis = this._get_ProteinData_ReturnPromise_CallbackFunction.bind(this)
    private _update_PageState_FromChildComponent_SaveCall_BindThis = this._update_PageState_FromChildComponent_SaveCall.bind(this);

    private _DO_NOT_CALL_BoundMethods_TypeTest() { // Function only to test that methods that are .bind(this) are correct function signature

        const _get_ProteinData_ReturnPromise_CallbackFunction: ProteinPositionFilter_UserInput__Component__Get_ProteinData_Root_UserSelectionData_Root_ReturnPromise_CallbackFunction = this._get_ProteinData_ReturnPromise_CallbackFunction
        const _update_PageState_FromChildComponent_SaveCall_BindThis : ProteinPositionFilter_UserInput__Component__Save_CallbackFunction = this._update_PageState_FromChildComponent_SaveCall
    }

    private _promise_InProgress_ProteinPositionFilter_UserInput__Component__ProteinData_Root: Promise<ProteinPositionFilter_UserInput__Component__ProteinData_Root>
    private _proteinPositionFilter_UserInput__Component__ProteinData_Root : ProteinPositionFilter_UserInput__Component__ProteinData_Root
    private _proteinPositionFilter_UserInput__Component__Existing_userSelections : ProteinPositionFilter_UserInput__Component__UserSelectionData_Root

    /**
     *
     */
    constructor(props : ProteinPositionFilter_UserSelections_Props) {
        super(props);

        try {
            this._update_Local_Property_From_Props___proteinPositionFilter_UserInput__Component__Existing_userSelections({ proteinPositionFilter_UserSelections_StateObject: props.proteinPositionFilter_UserSelections_StateObject })

            this.state = {
                forceRerender_Object: {}
            }
        } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }
    }

    /**
     *
     */
    shouldComponentUpdate(nextProps: Readonly<ProteinPositionFilter_UserSelections_Props>, nextState: Readonly<ProteinPositionFilter_UserSelections_State>, nextContext: any): boolean {

        if (
            this.props.proteinPositionFilter_UserSelections_Component_Force_ReRender_Object !== nextProps.proteinPositionFilter_UserSelections_Component_Force_ReRender_Object
            || this.state.forceRerender_Object !== nextState.forceRerender_Object ) {
            return true;
        }

        return false;
    }

    /**
     *
     */
    componentDidUpdate( prevProps: Readonly<ProteinPositionFilter_UserSelections_Props>, prevState: Readonly<ProteinPositionFilter_UserSelections_State>, snapshot?: any ) {
        try {
            if ( this.props.proteinPositionFilter_UserSelections_Component_Force_ReRender_Object !== prevProps.proteinPositionFilter_UserSelections_Component_Force_ReRender_Object ) {

                //  One of the Props objects changed so create new versions of Local Properties

                this._update_Local_Property_From_Props___proteinPositionFilter_UserInput__Component__Existing_userSelections({ proteinPositionFilter_UserSelections_StateObject: this.props.proteinPositionFilter_UserSelections_StateObject })

                this.setState({ forceRerender_Object: {} })
            }
        } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }
    }

    /**
     *
     */
    private _update_Local_Property_From_Props___proteinPositionFilter_UserInput__Component__Existing_userSelections(
        {
            proteinPositionFilter_UserSelections_StateObject
        } : {
            proteinPositionFilter_UserSelections_StateObject: ProteinPositionFilter_UserSelections_StateObject
        }
    ): void {

        this._proteinPositionFilter_UserInput__Component__Existing_userSelections = new ProteinPositionFilter_UserInput__Component__UserSelectionData_Root();

        {
            const selectedProteins_ForChildComponent: Array<ProteinPositionFilter_UserInput__Component__UserSelectionData_SingleProtein> = []

            const proteinPositionFilter_UserSelections = proteinPositionFilter_UserSelections_StateObject.getSelections_Ranges();

            if ( proteinPositionFilter_UserSelections && proteinPositionFilter_UserSelections.entriesMap_Key_proteinSequenceVersionId ) {

                for ( const proteinPositionFilter_MapEntry of proteinPositionFilter_UserSelections.entriesMap_Key_proteinSequenceVersionId.entries() ) {

                    const proteinPositionFilter = proteinPositionFilter_MapEntry[ 1 ];

                    const selectedProtein_ForChildComponent = new ProteinPositionFilter_UserInput__Component__UserSelectionData_SingleProtein()
                    selectedProteins_ForChildComponent.push( selectedProtein_ForChildComponent );

                    selectedProtein_ForChildComponent.proteinSequenceVersionId = proteinPositionFilter.proteinSequenceVersionId;

                    if ( ! proteinPositionFilter.fullProteinSelected ) {

                        selectedProtein_ForChildComponent.ranges = []
                        for ( const range of proteinPositionFilter.rangeEntries ) {

                            const selectedProteinRange_ForChildComponent = new ProteinPositionFilter_UserInput__Component__UserSelectionData_SingleRange();
                            selectedProtein_ForChildComponent.ranges.push( selectedProteinRange_ForChildComponent );

                            selectedProteinRange_ForChildComponent.start = range.proteinPosition_Start;
                            selectedProteinRange_ForChildComponent.end = range.proteinPosition_End;
                        }
                    }
                }
            }

            this._proteinPositionFilter_UserInput__Component__Existing_userSelections.proteins = selectedProteins_ForChildComponent;
        }
    }

    /**
     *
     */
    private _get_ProteinData_ReturnPromise_CallbackFunction() : Promise<ProteinPositionFilter_UserInput__Component__ProteinData_Root> {

        if ( this._proteinPositionFilter_UserInput__Component__ProteinData_Root ) {

            return Promise.resolve( this._proteinPositionFilter_UserInput__Component__ProteinData_Root )  // EARLY RETURN
        }

        if ( this._promise_InProgress_ProteinPositionFilter_UserInput__Component__ProteinData_Root ) {

            // EARLY RETURN

            return this._promise_InProgress_ProteinPositionFilter_UserInput__Component__ProteinData_Root
        }

        const promise_InProgress_proteinPositionFilter_UserSelections_Proteins_Names_Lengths_Data = proteinPositionFilter_UserSelections_Build_ProteinNamesLengths_Data_ForComponent({
            projectSearchIds: this.props.projectSearchIds,
            commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root: this.props.commonData_LoadedFromServer_PerSearch_Plus_SomeAssocCommonData__Except_ModMainPage__Root
        })

        this._promise_InProgress_ProteinPositionFilter_UserInput__Component__ProteinData_Root = new Promise<ProteinPositionFilter_UserInput__Component__ProteinData_Root>((resolve, reject) => { try {

            promise_InProgress_proteinPositionFilter_UserSelections_Proteins_Names_Lengths_Data.catch(reason => {

                this._promise_InProgress_ProteinPositionFilter_UserInput__Component__ProteinData_Root = undefined
                reject( reason )
            })
            promise_InProgress_proteinPositionFilter_UserSelections_Proteins_Names_Lengths_Data.then(value => { try {

                this._proteinPositionFilter_UserInput__Component__ProteinData_Root = value.proteinPositionFilter_UserInput__Component__ProteinData_Root

                this._promise_InProgress_ProteinPositionFilter_UserInput__Component__ProteinData_Root = undefined

                resolve( this._proteinPositionFilter_UserInput__Component__ProteinData_Root )

            } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }})

        } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }})

        return this._promise_InProgress_ProteinPositionFilter_UserInput__Component__ProteinData_Root
    }

    /**
     *
     */
    private _update_PageState_FromChildComponent_SaveCall( params: ProteinPositionFilter_UserInput__Component__Save_CallbackFunction_Params ) {

        const entriesMap_Key_proteinSequenceVersionId : Map<number, ProteinPositionFilter_UserSelections_StateObject_Get_RangeEntries_For_ProteinSequenceVersionId> = new Map();

        for ( const protein_FromChild of params.userSelections.proteins ) {

            const proteinSequenceVersionId = protein_FromChild.proteinSequenceVersionId;

            const result_SingleProtein = new ProteinPositionFilter_UserSelections_StateObject_Get_RangeEntries_For_ProteinSequenceVersionId();
            entriesMap_Key_proteinSequenceVersionId.set( proteinSequenceVersionId, result_SingleProtein );

            result_SingleProtein.proteinSequenceVersionId = proteinSequenceVersionId;

            if ( protein_FromChild.ranges && protein_FromChild.ranges.length > 0 ) {

                result_SingleProtein.rangeEntries = [];

                for ( const protein_FromChild_range of protein_FromChild.ranges ) {
                    const resultRange = new ProteinPositionFilter_UserSelections_StateObject_Get_RangeEntries_SingleRange();
                    result_SingleProtein.rangeEntries.push( resultRange );

                    resultRange.proteinPosition_Start = protein_FromChild_range.start;
                    resultRange.proteinPosition_End = protein_FromChild_range.end;
                }
            } else {
                result_SingleProtein.fullProteinSelected = true;
            }
        }

        const new_PageState = new ProteinPositionFilter_UserSelections_StateObject_Get_RangeEntries_Root();
        new_PageState.entriesMap_Key_proteinSequenceVersionId = entriesMap_Key_proteinSequenceVersionId;

        this.props.proteinPositionFilter_UserSelections_StateObject.setSelections_Ranges( new_PageState );

        this.props.updateMadeTo_proteinPositionFilter_UserSelections_StateObject_Callback();
    }

    /**
     *
     */
    render() {

        const paddingTopSize = 4;

        return (
            <React.Fragment>

                {/* Parent is CSS Grid with 2 Columns */}

                <div className=" filter-common-filter-label " style={ { paddingTop: paddingTopSize } }>
                    Filter On Protein Position:

                    <Tooltip__green_question_mark_in_circle__tooltip_on_hover__Component
                        title={
                            <span>
                                Use this option to define a one or more proteins and (optionally) regions in those proteins.
                                Only results that map to at least one of those proteins (or regions) will be shown.
                                Click "Add Protein" to add a new protein or region to the filter.
                            </span>
                        }
                    />
                </div>

                <div className=" filter-common-selection-block "  style={ { paddingTop: paddingTopSize } }>
                    <div className=" filter-common-selection-inner-block ">
                        <div className=" left-margin-same-as-checkbox ">
                            {/* left-margin-same-as-checkbox; to align with checkbox in Unique Peptide */}

                            {/*   ProteinPositionFilter_UserInputOverlay__MainOverlay_Component   */}

                            {/*{ ( ! this.state.proteinPositionFilter_UserInput__Component__ProteinData ) ? (*/}

                            {/*    <div>*/}
                            {/*        Loading Data...*/}
                            {/*    </div>*/}
                            {/*) : (*/}

                            <div >
                                <ProteinPositionFilter_UserInput__Component
                                    proteinData_InitiallyProvided={ this._proteinPositionFilter_UserInput__Component__ProteinData_Root }
                                    get_ProteinData_Root_UserSelectionData_Root_ReturnPromise_CallbackFunction={ this._get_ProteinData_ReturnPromise_CallbackFunction_BindThis }
                                    userSelections={ this._proteinPositionFilter_UserInput__Component__Existing_userSelections }
                                    callbackOn_Save_Clicked={ this._update_PageState_FromChildComponent_SaveCall_BindThis }
                                />
                            </div>

                            {/*)}*/}
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }

}
